import { render, staticRenderFns } from "./Staff02.vue?vue&type=template&id=c9b4fc74&scoped=true&"
import script from "./Staff02.vue?vue&type=script&lang=js&"
export * from "./Staff02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b4fc74",
  null
  
)

export default component.exports